var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.346 9.624c1.506 1.035.633 5.037-1.95 8.94-2.584 3.9-5.899 6.225-7.405 5.19s-.633-5.037 1.95-8.939c2.584-3.901 5.899-6.225 7.405-5.19M.822 9.624c-1.506 1.035-.633 5.037 1.95 8.94 2.584 3.9 5.899 6.225 7.405 5.19s.633-5.037-1.95-8.939C5.643 10.914 2.328 8.59.822 9.625M20.448 5.027c0 2.776-3.745 5.026-8.365 5.026s-8.365-2.25-8.365-5.026S7.463 0 12.083 0s8.365 2.25 8.365 5.027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.084 0h24v24h-24z"
  })))));
};
export default Svg24;